import PerformanceDashboard from "./Dashboard";

export const PerformanceRoutes = {
    PerformanceDashboard,
}